import { render } from "./ViewInvoice.vue?vue&type=template&id=1919ecd6&scoped=true"
import script from "./ViewInvoice.vue?vue&type=script&lang=js"
export * from "./ViewInvoice.vue?vue&type=script&lang=js"

import "./ViewInvoice.vue?vue&type=style&index=0&id=1919ecd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1919ecd6"]])

export default __exports__